import type { SearchResult } from '../../shared/search';
import { splitSearchSnippet } from '../lib/search';

export default function SearchSnippet({ result }: { result: SearchResult }) {
  const sourceLabels = { script: 'Script', scratchpad: 'Scratchpad', brief: 'Brief field', metadata: 'Title / client / project' };
  const parts = splitSearchSnippet(result.snippet);
  const plainSnippet = parts.map((part) => part.text).join('');
  const showFieldTitle = result.source === 'brief' && result.field_title &&
    !plainSnippet.startsWith(`${result.field_title}\n`);
  return (
    <div className="border-t border-line pt-3.5 mt-4 flex flex-col sm:flex-row sm:items-baseline gap-2 sm:gap-3.5">
      <span className="self-start shrink-0 font-mono text-[10px] leading-normal uppercase tracking-[0.07em] text-accent bg-accent/10 px-2 py-1 rounded-sm">
        {sourceLabels[result.source]}
      </span>
      <p className="min-w-0 text-[13px] leading-[1.8] text-muted break-words">
        {showFieldTitle && <span className="font-semibold text-fg">{result.field_title}: </span>}
        {parts.map((part, index) => part.matched
          ? <mark key={index} className="bg-accent/15 text-accent font-semibold px-0.5 rounded-sm">{part.text}</mark>
          : part.text)}
      </p>
    </div>
  );
}

